import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';
import { BasePage } from 'src/app/core/base-page';
import { SalesPerson } from 'src/app/data/schema/sales-person';
import { SelectOption } from 'src/app/core/component/form-inputs/select-input/select-input.component';
import { Raffle } from 'src/app/data/schema/raffle';

@Component({
  selector: 'app-seller-select',
  templateUrl: './seller-select.component.html',
  styleUrls: ['./seller-select.component.scss'],
})
export class SellerSelectComponent extends BasePage implements OnInit {

  @Input() label: string;
  @Input() selectedSalesPersonId: number;
  @Input() excludeOrganization = false;
  @Output() selectedSalesPersonIdChange = new EventEmitter<number>();

  sellerOptions: SelectOption[] = [];
  teamOptions: SelectOption[] = [];
  selectedSalesTeam: string;
  salesPeople: SalesPerson[] = [];


  constructor(
    authSvc: AuthenticationService,
  ) {
    super(authSvc);
  }

  get raffle() { return Raffle.currentRaffle; }

  ngOnInit() {
    this.loadData();
  }

  onSalesTeamSelected(event: string) {
    if (this.teamOptions.length === 1) {
      return;
    }

    this.selectedSalesTeam = event;

    // filter the sales group options down to the sales team id
    this.sellerOptions = this.salesPeople.filter(p => p.teamName === this.selectedSalesTeam).map(p => ({
      value: p.salesPersonId,
      displayValue: p.code
    }));

    if (!this.excludeOrganization) {
      this.sellerOptions.push({
        value: 0,
        displayValue: this.raffle.organizationName
      });
    }

    // if the selected sales person id is not in the sales people array, then set it to null
    if (!this.sellerOptions.some(p => p.value === this.selectedSalesPersonId)) {
      this.selectedSalesPersonId = null;
      this.onSellerSelected();
    }
  }

  onSellerSelected() {
    this.selectedSalesPersonIdChange.emit(this.selectedSalesPersonId);
  }

  private async loadData() {
    await this.loadSalesPeople();
    await this.loadSalesTeams();

    // If we have a team with a name other than "unassigned" then
    if (this.teamOptions.some(t => t.displayValue !== 'Unassigned')) {
      if (!this.excludeOrganization) {
        this.teamOptions.push({
          value: this.raffle.organizationName,
          displayValue: this.raffle.organizationName
        });
      }
    } else {
      // There are no teams, so just set the sales options to all the sales people
      this.sellerOptions = this.salesPeople.map(p => ({
        value: p.salesPersonId,
        displayValue: p.code
      }));
      if (!this.excludeOrganization) {
        this.sellerOptions.push({
          value: 0,
          displayValue: this.raffle.organizationName
        });
      }
    }

    // look for the current sales person id in the sales people array
    const currentSalesPerson = this.salesPeople.find(p => p.salesPersonId === this.selectedSalesPersonId);
    if (currentSalesPerson) {
      this.onSalesTeamSelected(currentSalesPerson.teamName);
    }
  }

  private async loadSalesPeople() {
    const all = await SalesPerson.fetchSalesPeopleByRaffle(this.raffle.raffleId);
    this.salesPeople = all.filter(p => p.isActive);
    // any unassigned sales people should get a sales team of 0
    for (const person of this.salesPeople) {
      if (person.salesTeamId == null) {
        person.teamName = 'Unassigned';
      }
    }
  }

  private async loadSalesTeams() {
    let teams = this.salesPeople.map(p => p.teamName).filter(t => t != null);
    // remove duplicates
    teams = [...new Set(teams)];
    teams.sort((a, b) => a.localeCompare(b));

    if (teams.length > 0) {
      this.teamOptions = teams.map(t => ({
        value: t,
        displayValue: t
      }));
    }
  }
}
